import React, { useState } from "react";
import Figma from "../images/figma.svg";
import ReactLogo from "../images/react-logo.svg";
import NodeLogo from "../images/node-logo.svg";
import Firebase from "../images/firebase.svg";
import Android from "../images/android.svg";
import JavaScriptLogo from "../images/javascript-logo.svg";

export default function Skills() {
  const SkillsComp = ({ id, className, src, title }) => {
    return (
      <div className={`comp ${className}`}>
        <div id={id} className="comp-mask">
          <p>{title}</p>
        </div>
        <img src={src} alt="" />
      </div>
    );
  };

  const [filter, setFilter] = useState("");
  const [link, setLink] = useState("");

  window.onload = () => {
    setFilter(["active", "active", "active", "active", "active", "active"]);
    setLink(["active", "", "", ""]);
  };

  const filterSkills = (item) => {
    switch (item) {
      case 0:
        setFilter(["active", "active", "active", "active", "active", "active"]);
        setLink(["active", "", "", ""]);
        break;
      case 1:
        setFilter(["active", "", "", "", "", ""]);
        setLink(["", "active", "", ""]);
        break;
      case 2:
        setFilter(["", "active", "active", "active", "", ""]);
        setLink(["", "", "active", ""]);
        break;
      case 3:
        setFilter(["", "", "active", "", "active", "active"]);
        setLink(["", "", "", "active"]);
        break;

      default:
        break;
    }
  };

  return (
    <div id="section3" className="skills">
      <div className="skills-title">
        <h2>My Skills</h2>
      </div>

      <div className="skills-links">
        <ul>
          <li
            className={link[0]}
            onClick={() => {
              filterSkills(0);
            }}
          >
            All
          </li>
          <li
            className={link[1]}
            onClick={() => {
              filterSkills(1);
            }}
          >
            UX/UI
          </li>
          <li
            className={link[2]}
            onClick={() => {
              filterSkills(2);
            }}
          >
            Websites
          </li>
          <li
            className={link[3]}
            onClick={() => {
              filterSkills(3);
            }}
          >
            Applications
          </li>
        </ul>
      </div>

      <div className="skills-comp">
        <SkillsComp
          id="comp1"
          className={filter[0]}
          src={Figma}
          title="Figma"
        />
        <SkillsComp
          id="comp6"
          className={filter[1]}
          src={JavaScriptLogo}
          title="JavaScript"
        />
        <SkillsComp
          id="comp2"
          className={filter[2]}
          src={ReactLogo}
          title="React"
        />
        <SkillsComp
          id="comp3"
          className={filter[3]}
          src={NodeLogo}
          title="Node JS"
        />
        <SkillsComp
          id="comp4"
          className={filter[4]}
          src={Firebase}
          title="Firebase"
        />
        <SkillsComp
          id="comp5"
          className={filter[5]}
          src={Android}
          title="Android"
        />
      </div>
    </div>
  );
}
